import FormattableTextField from './FormattableTextField'

export default class ReferenceField extends FormattableTextField {
    protected format(value: string = ''): string {
        return value.replace(/[^\w_-]+/g, '')
    }
}
